import * as React from "react";
import {MOMENT_MONTH_FORMAT} from "../../utils/date-utils";
import {DateRange} from "../../common/dtos";
import {capitalize} from "lodash";

interface MonthNameProps {
  dateRange: DateRange;
}

class MonthName extends React.Component<MonthNameProps, {}> {

  public render() {
    const {start, end} = this.props.dateRange;

    let label = `${start.year()}`;

    const startMonth = capitalize(start.format(MOMENT_MONTH_FORMAT));
    const endMonth = capitalize(end.format(MOMENT_MONTH_FORMAT));

    label = `${label} ${startMonth}`
    if (start.year() !== end.year()) {
      label = `${label} - ${end.year()} ${endMonth}`
    } else if (start.month() !== end.month()) {
      label = `${label} - ${endMonth}`
    }

    return (
      <div>{label}</div>
    );
  }
}

export default MonthName;


// WEBPACK FOOTER //
// ./src/event/header/MonthName.tsx